export const OPEN_DIALOG_EVENTS = "OPEN_DIALOG_EVENTS";
export const CLOSE_DIALOG_EVENTS = "CLOSE_DIALOG_EVENTS";
export const SET_EVENT_TABLE = "SET_EVENT_TABLE";
export const SET_EVENT_TABLE_SUCCESS = "SET_EVENT_TABLE_SUCCESS";
export const SET_EVENT_TABLE_ERROR = "SET_EVENT_TABLE_ERROR";
